<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Loading State -->
    <div v-if="loading" class="loading_wrapper">
      <div class="spinner"></div>
      <p class="loading_text">{{ $t("TABLES.loadingData") || "جاري التحميل..." }}</p>
    </div>
    <!-- End:: Loading State -->

    <!-- Start:: Main Section -->
    <main v-else>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Users Statistics =========== -->
      <h6 class="section-title mt-4 mb-3">{{ $t("PLACEHOLDERS.users_statistics") }}</h6>
      <div class="statics">
        <div class="row">
          <!-- Clients Count -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box clickable" @click="goTo('AllClients')">
              <div class="icon icon-primary">
                <i class="fas fa-users"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.clients_count") }}</span>
                <p class="number_box">{{ statics.clients || 0 }}</p>
              </div>
            </div>
          </div>

          <!-- Print Shops Count -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box clickable" @click="goTo('AllProviders')">
              <div class="icon icon-primary">
                <i class="fas fa-print"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("TITLES.PrintShops") || "المطابع" }}</span>
                <p class="number_box">{{ statics.print_shops || 0 }}</p>
              </div>
            </div>
          </div>

          <!-- Representatives Count -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box clickable" @click="goTo('AllRepresentatives')">
              <div class="icon icon-primary">
                <i class="fas fa-motorcycle"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("TITLES.Representatives") || "المناديب" }}</span>
                <p class="number_box">{{ statics.representatives || 0 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Users Statistics =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomePage",

  computed: {
    ...mapGetters({
      getAppTheme: "AppThemeModule/getAppTheme",
    }),
  },

  data() {
    return {
      statics: {},
      loading: false,
    };
  },

  methods: {
    async getStatics() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "statistic",
        });

        // API returns: { status: 200, message: "...", data: { data: {...} } }
        if (res.data && res.data.data && res.data.data.data) {
          this.statics = res.data.data.data;
        } else if (res.data && res.data.data) {
          this.statics = res.data.data;
        } else {
          this.statics = {};
        }
      } catch (error) {
        console.error("Statistics API Error:", error);
        if (error.response?.data?.message) {
          this.$message.error(error.response.data.message);
        } else {
          this.$message.error("حدث خطأ في جلب الإحصائيات");
        }
      } finally {
        this.loading = false;
      }
    },

    goTo(routeName) {
      this.$router.push({ name: routeName });
    },
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper {
  .section-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--theme_text_clr);
    margin-bottom: 24px;
    padding-bottom: 12px;
    border-bottom: 2px solid var(--very_light_theme_clr);
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      right: 0;
      width: 60px;
      height: 2px;
      background: var(--main_theme_clr);
      border-radius: 2px;
    }
  }

  .statics {
    margin-bottom: 40px;

      .box {
      background: var(--theme_second_bg_clr);
      padding: 28px;
      margin-bottom: 24px;
      border-radius: 16px;
      border: 1px solid var(--very_light_theme_clr);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      gap: 24px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;

      &.clickable {
        cursor: pointer;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 4px;
        height: 100%;
        background: var(--main_theme_clr);
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0, 0, 0, 0.06);
        transform: translateY(-4px);
        border-color: var(--very_light_theme_clr);

        &::before {
          opacity: 1;
        }

        .icon {
          transform: scale(1.05);
        }
      }

      .icon {
        height: 72px;
        min-width: 72px;
        width: 72px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: transform 0.3s ease;
        position: relative;

        i {
          font-size: 30px;
          position: relative;
          z-index: 1;
        }

        &.icon-primary {
          background: linear-gradient(135deg, rgba(62, 182, 212, 0.12) 0%, rgba(62, 182, 212, 0.08) 100%);
          i {
            color: #3eb6d4;
          }
        }

        &.icon-success {
          background: linear-gradient(135deg, rgba(76, 175, 80, 0.12) 0%, rgba(76, 175, 80, 0.08) 100%);
          i {
            color: #4caf50;
          }
        }

        &.icon-warning {
          background: linear-gradient(135deg, rgba(255, 152, 0, 0.12) 0%, rgba(255, 152, 0, 0.08) 100%);
          i {
            color: #ff9800;
          }
        }

        &.icon-danger {
          background: linear-gradient(135deg, rgba(244, 67, 54, 0.12) 0%, rgba(244, 67, 54, 0.08) 100%);
          i {
            color: #f44336;
          }
        }

        &.icon-info {
          background: linear-gradient(135deg, rgba(33, 150, 243, 0.12) 0%, rgba(33, 150, 243, 0.08) 100%);
          i {
            color: #2196f3;
          }
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;

        span {
          font-size: 15px;
          color: var(--theme_secondary_text_clr);
          margin-bottom: 10px;
          font-weight: 500;
          letter-spacing: 0.2px;
        }

        p.number_box {
          font-size: 36px;
          color: var(--theme_text_clr);
          font-weight: 800;
          margin: 0;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }
      }
    }
  }
}

// Light Theme Specific Enhancements
:root:not(.dark_theme) {
  .show_all_content_wrapper {
    .statics {
      .box {
        background: #ffffff;
        border-color: #e5e7eb;

        &:hover {
          border-color: #cbd5e1;
          background: #fafbfc;
        }

        .info_box {
          span {
            color: #64748b;
          }

          p.number_box {
            color: #0f172a;
          }
        }
      }
    }

    .section-title {
      color: #1e293b;
      border-bottom-color: #e2e8f0;

      &::after {
        background: linear-gradient(90deg, #3eb6d4 0%, #2a8ba8 100%);
      }
    }
  }
}

// Dark Theme Specific Adjustments
:root .dark_theme {
  .show_all_content_wrapper {
    .statics {
      .box {
        background: var(--theme_second_bg_clr);
        border-color: var(--very_light_theme_clr);
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.3);

        &:hover {
          border-color: var(--main_theme_clr);
          background: var(--theme_second_bg_clr);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3), 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .info_box {
          span {
            color: var(--theme_secondary_text_clr);
          }

          p.number_box {
            color: var(--theme_text_clr);
          }
        }
      }
    }

    .section-title {
      color: var(--theme_text_clr);
      border-bottom-color: var(--very_light_theme_clr);
    }
  }
}

.loading_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;

  .spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--main_theme_clr, #3eb6d4);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }

  .loading_text {
    font-size: 16px;
    color: var(--theme_text_clr, #333);
    margin-top: 10px;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>
